(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.heroBound) return;
    root.dataset.heroBound = 'true';

    var track = root.querySelector('[data-hero-track]');
    if (!track) return;

    var slides = function () {
      return Array.prototype.slice.call(track.querySelectorAll('[data-hero-slide]'));
    };
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var firstImg = track.querySelector('[data-hero-slide] img');
    var cloned = false;
    var ready = false;
    var timer = null;
    var stopped = false;
    var speed = (Number(root.dataset.speed) || 5) * 1000;

    function currentIndex() {
      var width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    }

    function goTo(index, behavior) {
      var needsLayout = !ready;
      enableReady();
      var run = function () {
        var width = track.clientWidth || 1;
        var max = Math.max(0, slides().length - 1);
        var next = Math.max(0, Math.min(index, max));
        track.scrollTo({
          left: next * width,
          behavior: behavior || 'auto',
        });
        var keepFocus = dots.indexOf(document.activeElement) !== -1;
        syncDots();
        if (keepFocus && dots[next]) dots[next].focus();
      };
      // Wait for clone + overflow styles to flush before the first scroll,
      // otherwise browsers skip smooth scrolling and jump.
      if (needsLayout) {
        requestAnimationFrame(function () {
          requestAnimationFrame(run);
        });
      } else {
        run();
      }
    }

    function syncDots() {
      var index = currentIndex();
      var slideList = slides();
      dots.forEach(function (dot, i) {
        var selected = i === index;
        dot.setAttribute('aria-selected', selected ? 'true' : 'false');
        dot.tabIndex = selected ? 0 : -1;
      });
      slideList.forEach(function (slide, i) {
        if (i === index) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function stopAutoplay() {
      stopped = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function cloneDeferred() {
      if (cloned) return;
      cloned = true;
      track.querySelectorAll('template[data-hero-deferred]').forEach(function (tpl) {
        tpl.parentNode.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
      });
    }

    function enableReady() {
      cloneDeferred();
      if (ready) return;
      ready = true;
      root.dataset.heroReady = 'true';
      track.classList.add('hero-slider--ready');
      void track.offsetHeight;
      track.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', function () {
        goTo(currentIndex(), 'auto');
      });
    }

    function startAutoplay() {
      if (stopped || reduceMotion.matches || root.dataset.autoplay !== 'true' || slides().length < 2) {
        return;
      }
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        goTo((currentIndex() + 1) % slides().length);
      }, speed);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(i, reduceMotion.matches ? 'auto' : 'smooth');
      });
      dot.addEventListener('keydown', function (event) {
        var max = dots.length - 1;
        var next = i;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = i === max ? 0 : i + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = i === 0 ? max : i - 1;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = max;
        } else {
          return;
        }
        event.preventDefault();
        stopAutoplay();
        goTo(next, reduceMotion.matches ? 'auto' : 'smooth');
      });
    });

    track.addEventListener(
      'pointerdown',
      function () {
        stopAutoplay();
        enableReady();
      },
      { passive: true }
    );

    function arm() {
      enableReady();
      startAutoplay();
    }

    if (!firstImg || firstImg.complete) {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(arm, { timeout: 1500 });
      } else {
        setTimeout(arm, 0);
      }
    } else {
      firstImg.addEventListener('load', arm, { once: true });
      firstImg.addEventListener('error', arm, { once: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-hero-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
